<template>
  <div class="sidebar-left">
    <div class="sidebar">

      <!-- Logged In User Profile Sidebar -->
      <user-profile-sidebar
        :shall-show-user-profile-sidebar="shallShowUserProfileSidebar"
        :profile-user-data="profileUserData"
        @close-sidebar="$emit('update:shall-show-user-profile-sidebar', false)"
      />

      <!-- Sidebar Content -->
      <div
        class="sidebar-content"
        :class="{'show': mqShallShowLeftSidebar}"
      >

        <!-- Sidebar close icon -->
        <span class="sidebar-close-icon">
          <feather-icon
            icon="XIcon"
            size="16"
            @click="$emit('update:mq-shall-show-left-sidebar', false)"
          />
        </span>

        <!-- Header -->
        <div class="chat-fixed-search">
          <div class="d-flex align-items-center w-100">
            <div class="sidebar-profile-toggle">
              <b-avatar
                size="42"
                class="cursor-pointer badge-minimal avatar-border-2"
                :src="require(`@/assets/images/avatars/${profileUserMinimalData.avatar || '1'}-small.png`)"
                variant="transparent"
                :badge="false"
                badge-variant="success"
                @click.native="$emit('show-user-profile')"
              />
            </div>
            <!-- Search -->
            <b-input-group class="input-group-merge ml-1 w-100 round">
              <b-input-group-prepend is-text>
                <feather-icon
                  icon="SearchIcon"
                  class="text-muted"
                />
              </b-input-group-prepend>
              <b-form-input
                v-model="searchQuery"
                placeholder="Search..."
              />
            </b-input-group>
            <div>
              <b-button variant="link" size="sm" style="padding-right: 0" @click="withMessageOnly=!withMessageOnly">
                <i v-if="withMessageOnly" class="fa-regular fa-comment-dots"></i>
                <i v-if="!withMessageOnly" class="fa-regular fa-comment"></i>
              </b-button>
            </div>
          </div>
        </div>

        <!-- ScrollArea: Chat & Contacts -->
        <vue-perfect-scrollbar
          :settings="perfectScrollbarSettings"
          class="chat-user-list-wrapper list-group scroll-area"
        >

          <!-- Chats -->
          <ul class="chat-users-list chat-list media-list">
            <chat-contact
              v-for="session in filteredChatsContacts"
              :key="session.id"
              :session="session"
              tag="li"
              :class="{'active': activeChatContactId === session.id}"
              :is-chat-contact="false"
              :no-avatar="noAvatar"
              @click="$emit('open-chat', session.id)"
            />
          </ul>

          <div v-if="loading && filteredChatsContacts.length <= 0" class="text-center mt-1">
            <b-spinner label="Loading..." />
          </div>
        </vue-perfect-scrollbar>
      </div>

    </div>
  </div>
</template>

<script>
import {
  BAvatar, BInputGroup, BInputGroupPrepend, BFormInput,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { ref, computed } from '@vue/composition-api'
import ChatContact from './ChatContact.vue'
import UserProfileSidebar from './UserProfileSidebar.vue'
import { mapGetters } from 'vuex'

const searchFilterFunction = (searchQuery,session) => session.sessionName?.toLowerCase()?.includes(searchQuery.toLowerCase())

export default {
  components: {
        // 3rd party
    VuePerfectScrollbar,

    // SFC
    ChatContact,
    UserProfileSidebar,
  },
  data() {
    return {
      loading: true,
      // Search Query
      searchQuery: '',
      withMessageOnly: true,
      perfectScrollbarSettings: {
        maxScrollbarLength: 150,
      }
    }
  },
  props: {
    sessions: {
      type: Array,
      required: true,
    },
    contacts: {
      type: Array,
      required: true,
    },
    shallShowUserProfileSidebar: {
      type: Boolean,
      required: true,
    },
    profileUserData: {
      type: Object,
      required: true,
    },
    profileUserMinimalData: {
      type: Object,
      required: true,
    },
    activeChatContactId: {
      type: String,
      default: null,
    },
    mqShallShowLeftSidebar: {
      type: Boolean,
      required: true,
    },
    noAvatar: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters("chat", ["activeSession"]),

    filteredChatsContacts() {
      let $this = this
      let session = null
      session = this.sessions.filter(contact => searchFilterFunction(this.searchQuery, contact)) || []
      if(this.withMessageOnly){
        session = session.filter(s=>s.lastMessage != null || s.id === $this.activeSession?.id)
      }
      return session.sort((s1, s2) => {
        let time1 = s1.lastMessageTime != null ? $this.$moment.serverDate(s1.lastMessageTime) : $this.$moment(s1.creationTime)
        let time2 = s2.lastMessageTime != null ? $this.$moment.serverDate(s2.lastMessageTime) : $this.$moment(s2.creationTime)
        return time1.isBefore(time2) ? 1 : -1
      })
    },
    filteredContacts () {
      if(this.searchQuery == null || this.searchQuery === '') {
        return this.sessions
      }
      let $this = this
      this.contacts.filter(contact=>searchFilterFunction($this.searchQuery, contact))
    },
  },
  methods: {
    // Search Filter Function
    setLoading(loading) {
      this.loading = loading
    },
    searchFilterFunction(contact) {
      return contact.fullName.toLowerCase().includes(this.searchQuery.toLowerCase())
    },
    resolveChatContact(userId) {
      this.contacts.find(contact => contact.id === userId)
    },
    getAvatar(avatar) {
      try {
        return require(avatar)
      }catch (e) {
        console.warn("Error loading avatar", e)
      }

    }
  },
}
</script>
